export default __webpack_public_path__ + "static/media/logo_tiktok.e2640cbd.svg";